const config = {
  featureServices: [
    { name: "Island Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/FeatureServer/91" },
    { name: "Marine Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/FeatureServer/119" },
    { name: "Terrestrial Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/FeatureServer/93" },
  ],
  Print: {
    printServiceUrl: "https://devedp.ead.ae/server/rest/services/AlDaleela/AlDaleela_PrintTemplate/GPServer/Export%20Web%20Map",
    allowedFormats: ["Portable Document Format (PDF)","32-bit Portable Network Graphics (PNG32)", "Joint Photographic Experts Group (JPG)"],
    allowedLayouts: ["Print"]
  },
  Export: {
    printServiceUrlAr: "https://devedp.ead.ae/server/rest/services/AlDaleela/ExportWebMap_Arabic/GPServer/Export%20Web%20Map",
    printServiceUrlEng: "https://devedp.ead.ae/server/rest/services/AlDaleela/ExportWebMap_English/GPServer/Export%20Web%20Map",
    allowedFormats: ["32-bit Portable Network Graphics (PNG32)", "Joint Photographic Experts Group (JPG)"],
    allowedLayouts: ["Export"]
  },
  layerListServices: {
    english: [
      {
        parent: {name:"Scale based Labelling",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/95", visible: true},
        children: [
          { name: "Island  Names", id:"Island Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/91", visible: true },
          { name: "Marine  Names", id:"Marine Names",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/119", visible: true },
          { name: "Terrestrial  Names", id:"Terrestrial Names",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/93", visible: true },
          { name: "Protected Areas", id:"Protected Areas",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/90", visible: false },
          { name: "Pearl Sites", id:"Pearl Sites",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/89", visible: false }
        ]
      },
      {
        parent: {name:"Cluster",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/108", visible: false},
        children: [
          { name: "Island  Names", id:"Island Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/111", visible: true },
          { name: "Marine  Names", id:"Marine Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/110", visible: true },
          { name: "Terrestrial  Names", id:"Terrestrial Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/109", visible: true },
          { name: "Protected Areas", id:"Protected Areas", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/116", visible: false },
          { name: "Pearl Sites", id:"Pearl Sites", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/115", visible: false }
        ]
      }
    ],
    arabic: [
      {
        parent: {name:"التسمية حسب المقياس",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/103", visible: true},
        children: [
          { name: "مسميات الجزر",id:"Island Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/102", visible: true },
          { name: "المسميات البحرية",id:"Marine Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/101", visible: true },
          { name: "المسميات البرية",id:"Terrestrial Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/100", visible: true },
          { name: "المحميات الطبيعية", id:"Protected Areas",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/96", visible: false },
          { name: "مغاصات اللولو",id:"Pearl Sites", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/97", visible: false }
        ]
      },
      {
        parent: {name:"التكتل",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/104", visible: false},
        children: [
          { name: "مسميات الجزر",id:"Island Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/2", visible: true },
          { name: "المسميات البحرية",id:"Marine Names", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/105", visible: true },
          { name: "المسميات البرية", id:"Terrestrial Names",url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/3", visible: true },
          { name: "المحميات الطبيعية",id:"Protected Areas", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/107", visible: false },
          { name: "مغاصات اللولو",id:"Pearl Sites", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer/106", visible: false }
        ]
      }
    ]
  },
  basemapsConfig: {
    Arabic: [
      {
        title: "خريطة أساس رمادية داكنة بالعربية - الإحداثيات الجغرافية",
        id: "Basemap Arabic Dark Gray Geographic coordinates",
        thumbnailImg: "./images/Basemap Arabic Dark Gray Geographic coordinates.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_DarkGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "خريطة أساس رمادية داكنة بالعربية - إحداثيات ويب ميركاتور",
      //   id: "Basemap Arabic Dark Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/Arabic Dark Gray Web Mercator .png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_DarkGray_WM/MapServer"
      //   ]
      // },
      {
        title: "خريطة أساس رمادية فاتحة بالعربية - الإحداثيات الجغرافية",
        id: "Basemap Arabic Light Gray Geographic coordinates",
        thumbnailImg: "./images/Arabic light Gray Geographic.jpg",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_LightGray_GCS/MapServer"
        ]
      },
      {
        title: "صور الأقمار الصناعية",
        id: "Satellite imagery Arabic",
        thumbnailImg: "./images/ESRI Satellite Imagery.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/arcgis/rest/services/Pub/IMG_SAT_50CM_WM/MapServer"
        ]
      },
      {
        title: "صور الأقمار الصناعية",
        id: "Satellite imagery Arabic",
        thumbnailImg: "./images/ESRI World Imagery.png",
        baseLayers: [
          "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
        ]
      },
            {
        title: "خريطة طوبوغرافية",
        id: "Topographic Map Arabic",
        thumbnailImg: "./images/topo_Ar.png",
        baseLayers: [
          "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer"
        ]
      }
    ],
    English: [
      {
        title: "Dark Gray Geographic",
        id: "Basemap English Dark Gray Geographic coordinates",
        thumbnailImg: "./images/English Dark Gray Geographic.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_DarkGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "English Dark Gray Web Mercator",
      //   id: "Basemap English Dark Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/English Dark Gray Web Mercator.png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_DarkGray_WM/MapServer"
      //   ]
      // },
      {
        title: "Light Gray Geographic",
        id: "Basemap English Light Gray Geographic coordinates",
        thumbnailImg: "./images/English light Gray Geographic.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_LightGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "English Light Gray Web Mercator",
      //   id: "Basemap English Light Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/English Light Gray Web Mercator.png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_LightGray_WM/MapServer"
      //   ]
      // },
      {
        title: "Satellite Imagery",
        id: "Satellite imagery English",
        thumbnailImg: "./images/ESRI Satellite Imagery.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/arcgis/rest/services/Pub/IMG_SAT_50CM_WM/MapServer"
        ]
      },
      {
        title: "Satellite Imagery",
        id: "Satellite imagery English",
        thumbnailImg: "./images/ESRI World Imagery.png",
        baseLayers: [
          "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
        ]
      },
      {
        title: "Topographic Map",
        id: "Topographic Map English",
        thumbnailImg: "./images/Topo_Eng.png",
        baseLayers: [
          "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer"
        ]
      }
    ]
  },
  PortalUrl: "https://devedp.ead.ae/portal",
  ItemWebMapIDEng: "403917ff62254c7687270deca5340383",
  BaseUrl: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Service/MapServer"
};

export default config;
